import http from './http'

export default {
  getInvoices: params => http.get('/v2/nomination-invoices', { params }),
  getPdf: invoiceId => http.get(`/v2/nomination-invoices/${invoiceId}/pdf`, { silent: true }),
  getStripeSecret: invoiceId => http.post(`/v2/nomination-invoices/${invoiceId}/stripe-client-secret`, {}),
  confirmPayment: (invoiceId, data) => http.post(`/v2/nomination-invoices/${invoiceId}/confirm-payment`, data, { silent: true }),
  resend: (draftId, userId) => http.post(`/v2/drafts/${draftId}/nomination-invoices/users/${userId}/resend`, {}, { silent: true, localSuccess: true }),
  remind: draftId => http.post(`/v2/drafts/${draftId}/nomination-invoices/remind`, {}, { silent: true, localSuccess: true })
}



// WEBPACK FOOTER //
// ./src/services/api/invoices.js